import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  ToolbarPropsOverrides,
} from '@mui/x-data-grid-premium';
import GridToolbarBulkEditButton from './grid-toolbar-bulk-edit-button.component';

const IncDataGridToolbar = ({ toolbar }: ToolbarPropsOverrides) => {
  return (
    <GridToolbarContainer>
      {toolbar.columns && <GridToolbarColumnsButton />}
      {toolbar.bulkEdit && (
        <GridToolbarBulkEditButton bulkEdit={toolbar.bulkEdit} />
      )}
    </GridToolbarContainer>
  );
};

export default IncDataGridToolbar;
